import { userService } from '../_services';

const getDefaultState = () => {
  return {
    all: {},
    current: {},
    edit: {},
    tasks: {},
    selectList: {},
    setToken: {},
    loggedIn: true,
    loading: false
  }
}

export const users = {
    namespaced: true,
    state: getDefaultState(),
    actions: {
      resetState ({ commit }) {
        commit('resetState')
      },
      getCurrentUser({ commit }) {
        commit('getCurrentUserRequest');
        const user = JSON.parse(localStorage.getItem('user'))
        userService.getInfo(user.id)
        .then(
            user => commit('getCurrentUserSuccess', user),
            error => commit('getCurrentUserFailure', error)
        );
      },
      getById({ commit }, userid) {
        commit('getByIdRequest');
        userService.getInfo(userid)
        .then(
            user => commit('getByIdSuccess', user),
            error => commit('getByIdFailure', error)
        );
      },
      getAll({ commit },params) {
        commit('getAllRequest');
        userService.getAll(params)
          .then(
              users => commit('getAllSuccess', users),
              error => commit('getAllFailure', error)
          );
      },
      getSelectList({ commit }) {
        commit('getSelectListRequest');
        userService.getSelectList()
          .then(
              users => commit('getSelectListSuccess', users),
              error => commit('getSelectListFailure', error)
          );
      },
      update({ commit }, user){
        commit('updateUserRequest');
        userService.update(user)
        .then(
          user => commit('updateUserSuccess', user),
          error => commit('updateUserFailure', error)

        )
      },
      addUser({ dispatch, commit }, user) {
        commit('addUserRequest');
        return userService.addUser(user)
            .then(
              user => {
                  commit('addUserSuccess', user);
                  return user
              },
              error => {
                  commit('addUserFailure', error);
              }
          );
      },
      deleteUser({ commit }, userId){
        commit('deleteUserRequest');
        userService.deleteUser(userId)
        .then(
          commit('deleteUserSuccess'),
          error => commit('deleteUserFailure', error)
        )
        return true;
      },
      getAccessTasks({ commit }) {
        commit('getAccessTasksRequest');
        userService.getAccessTasks()
          .then(
              tasks => commit('getAccessTasksSuccess', tasks),
              error => commit('getAccessTasksFailure', error)
          );
      },
      respondToAccessTask({ commit }, payload) {
        commit('respondToAccessTaskRequest');
        userService.respondToAccessTask(payload)
          .then(
              tasks => commit('respondToAccessTaskSuccess', tasks),
              error => commit('respondToAccessTaskFailure', error)
          );
      },
      isLoggedIn({ commit }) {
        commit('isLoggedInRequest');
        userService.isLoggedIn()
        .then(
            user => commit('isLoggedInSuccess', user),
            error => commit('isLoggedInFailure', error)
        );
      }
    },
    mutations: {
        resetState (state) {
          Object.assign(state, getDefaultState())
        },
        getAllRequest(state) {
            //state.all = { loading: true };
            state.loading = true;
        },
        getAllSuccess(state, users) {
            state.all = users;
            state.loading = false;
        },
        getAllFailure(state, error) {
            state.all = { error };
            state.loading = false;
        },
        getSelectListRequest(state) {
            state.selectList = { loading: true };
        },
        getSelectListSuccess(state, users) {
            state.selectList = users;
        },
        getSelectListFailure(state, error) {
            state.selectList = { error };
        },
        getByIdRequest(state) {
            state.edit = { loading: true };
        },
        getByIdSuccess(state, user) {
            state.edit = user;
        },
        getByIdFailure(state, error) {
            state.edit = { error };
        },
        getCurrentUserRequest(state) { 
            state.loading = true;
        },
        getCurrentUserSuccess(state, user) {
            state.current = { user: user };
            state.loading = false;
        },
        getCurrentUserFailure(state, error) {
            state.current = { error };
            state.loading = false;
        },
        updateUserRequest(){
        },
        updateUserSuccess(state, user) {
            //state.current.user = user;
        },
        updateUserFailure(state, error) {
            state.update = { error };
        },
        getAccessTasksRequest(state) {
            state.tasks = { loading: true };
        },
        getAccessTasksSuccess(state, tasks) {
            state.tasks = { items: tasks };
        },
        getAccessTasksFailure(state, error) {
            state.tasks = { error };
        },
        respondToAccessTaskRequest(){
        },
        respondToAccessTaskSuccess(state, user) {
        },
        respondToAccessTaskFailure(state, error) {
        },
        deleteUserRequest(state, tag) {
          //state.current = tag
        },
        deleteUserSuccess(state) {
            state.current = {};
            return true;
        },
        deleteUserFailure(state, error) {
          //state.update = { error };
        },
        addUserRequest(state) {
            state.loading = true;
        },
        addUserSuccess(state, user) {
            state.current = user;
        },
        addUserFailure(state) {
            state.status = { error: true };
            state.current = null;
        },
        isLoggedInRequest(state) {
            //state.isLoggedIn = false;
        },
        isLoggedInSuccess(state, users) {
          if(users.success){
            state.isLoggedIn = true;
          }else{
            state.isLoggedIn = false;
          }
        },
        isLoggedInFailure(state, error) {
            state.isLoggedIn = false;
        }
    }
}